import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { ACTIONS_COL } from '@/types/interfaces';
import { DRAWER_CLOSED } from '@/constants/icons';
export default /*#__PURE__*/_defineComponent({
  __name: 'base-card',
  props: {
    isSelected: {
      type: Boolean
    },
    isExpanded: {
      type: Boolean
    },
    columnDefs: null,
    canSelect: {
      type: Boolean,
      default: true
    },
    canExpand: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    selectionDisabled: {
      type: Boolean,
      default: false
    },
    canRemove: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-select', 'row-click', 'row-dblclick', 'toggle-expand'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const relevantColumns = computed(() => {
      return props.columnDefs.headers.filter(header => header.visibility.card !== 'hide');
    });
    const rows = computed(() => {
      const headers = [];
      headers.push(relevantColumns.value.filter(e => {
        return e.row === 1;
      }));
      headers.push(relevantColumns.value.filter(e => {
        return e.row === 2;
      }));
      headers.push(relevantColumns.value.filter(e => {
        return e.row === 3;
      }));
      return headers;
    });
    const getStyleClass = rowIndex => {
      if (rowIndex === 1) return 'pa-1 flex-row';
      const baseClass = 'mx-1 fill-width justify-space-between flex-row';
      if (rowIndex === 0) return `ml-2 ${baseClass}`;
      if (rowIndex > 1) return `${baseClass} ml-1 overflow-hidden`;
      return baseClass;
    };
    return {
      __sfc: true,
      props,
      emit,
      relevantColumns,
      rows,
      getStyleClass,
      ACTIONS_COL,
      DRAWER_CLOSED
    };
  }
});